<aca-page-layout>
  <div class="aca-page-layout-header">
    <aca-search-ai-input-container
      *ngIf="searchAiInputState.active; else header"
      [agentId]="searchAiInputState.selectedAgentId">
    </aca-search-ai-input-container>
    <ng-template #header>
      <div class="aca-header-container">
        <h1 class="aca-page-title">
      {{ (selectedRowItemsCount < 1 ? 'APP.BROWSE.FAVORITES.TITLE' : 'APP.HEADER.SELECTED') | translate: { count: selectedRowItemsCount } }}
    </h1>
        <aca-toolbar [items]="actions"></aca-toolbar>
      </div>
    </ng-template>
  </div>

  <div class="aca-page-layout-content">
    <div class="aca-main-content">
      <adf-document-list
        #documentList
        acaDocumentList
        acaContextActions
        [currentFolderId]="'-favorites-'"
        [selectionMode]="'multiple'"
        [multiselect]="true"
        [navigate]="false"
        [sorting]="['modifiedAt', 'desc']"
        [sortingMode]="'client'"
        [imageResolver]="imageResolver"
        [displayCheckboxesOnHover]="true"
        (selectedItemsCountChanged)="onSelectedItemsCountChanged($event)"
        [isResizingEnabled]="true"
        [blurOnResize]="false"
        (node-dblclick)="handleNodeClick($event)"
        (name-click)="handleNodeClick($event)"
      >
        <adf-custom-empty-content-template>
          <adf-empty-content icon="star_rate" [title]="'APP.BROWSE.FAVORITES.EMPTY_STATE.TITLE'" subtitle="APP.BROWSE.FAVORITES.EMPTY_STATE.TEXT">
          </adf-empty-content>
        </adf-custom-empty-content-template>

        <data-columns>
          <ng-container *ngFor="let column of columns; trackBy: trackByColumnId">
            <ng-container *ngIf="column.template && !(column.desktopOnly && isSmallScreen)">
              <data-column
                [id]="column.id"
                [key]="column.key"
                [title]="column.title"
                [draggable]="column.draggable"
                [resizable]="column.resizable"
                [type]="column.type"
                [format]="column.format"
                [class]="column.class"
                [sortable]="column.sortable"
                [isHidden]="column.isHidden"
                [sortingKey]="column.sortingKey || column.key"
              >
                <ng-template let-context>
                  <adf-dynamic-column [id]="column.template" [context]="context"> </adf-dynamic-column>
                </ng-template>
              </data-column>
            </ng-container>

            <ng-container *ngIf="!column.template && !(column.desktopOnly && isSmallScreen)">
              <data-column
                [id]="column.id"
                [key]="column.key"
                [title]="column.title"
                [type]="column.type"
                [draggable]="column.draggable"
                [resizable]="column.resizable"
                [format]="column.format"
                [class]="column.class"
                [sortable]="column.sortable"
                [isHidden]="column.isHidden"
                [sortingKey]="column.sortingKey || column.key"
              >
              </data-column>
            </ng-container>
          </ng-container>
        </data-columns>
      </adf-document-list>

      <adf-pagination acaPagination [target]="documentList"> </adf-pagination>
    </div>

    <div class="aca-sidebar" *ngIf="infoDrawerOpened$ | async">
      <aca-info-drawer [node]="selection.last"></aca-info-drawer>
    </div>
  </div>
</aca-page-layout>
